import { render, staticRenderFns } from "./SwabSampleAnalysis.vue?vue&type=template&id=5d400b7e&"
import script from "./SwabSampleAnalysis.vue?vue&type=script&lang=ts&"
export * from "./SwabSampleAnalysis.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports